import { getDynamicSetting } from 'utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

const FINDINGS_ENDPOINT = 'findings/v1';

export const BASE_URL = `${serverUrl}/${FINDINGS_ENDPOINT}`;
